import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { addNewCountry, updateCountry } from "../../services/axios/apiManager";
import { toast } from "sonner";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { countryValidationSchema } from "./countriesValidations";
import LoadingSpinner from "../../Components/spinner";
const AddEditCountryModal = ({
  setShowModal,
  showModal,
  selectedCountry,
  setSelectedCountry,
  fetchCountries,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleCloseAddEditModal = () => {
    setSelectedCountry({});
    setShowModal(false);
  };

  const handleSubmitForm = async (data) => {
    if (selectedCountry?.id) {
      // // // Edit Country
      const res = await updateCountry({ id: selectedCountry.id, ...data });
      if (res?.data?.success) {
        await fetchCountries({ currentPage: 1, pageSize: 20 });
        toast.success("Country has been updated.", { duration: 2000 });
        handleCloseAddEditModal();
      } else {
        handleErrors(res, navigate, "Update Country:");
      }
    } else {
      // // // Add Country
      const res = await addNewCountry(data);
      if (res?.data?.success) {
        await fetchCountries({ currentPage: 1, pageSize: 20 });
        toast.success("A new country has been added.", { duration: 2000 });
        handleCloseAddEditModal();
      } else {
        handleErrors(res, navigate, "Add Country:");
      }
    }
  };
  return (
    <Modal
      show={showModal}
      onHide={handleCloseAddEditModal}
      centered
      className="text-light"
      backdrop="static"
      size="lg"
    >
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title>
          {selectedCountry?.id ? "Edit Country" : "Add New Country"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <Formik
          initialValues={{
            country_name: selectedCountry?.country_name || "",
            country_code: selectedCountry?.country_code || "",
            iso3_code: selectedCountry?.iso3_code || "",
            numeric_code: selectedCountry?.numeric_code || "",
            capital: selectedCountry?.capital || "",
            native_name: selectedCountry?.native_name || "",
          }}
          validationSchema={countryValidationSchema}
          onSubmit={async (values) => {
            try {
              setLoading(true);
              await handleSubmitForm(values);
            } catch (error) {
              console.log("Error upon Add Update Country", error);
            } finally {
              setLoading(false);
            }
          }}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <div className="row">
              {/* country_name */}
              <div className="col-md-6 mb-3">
                <Form.Label>Country Name*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter country name"
                  name="country_name"
                  value={values.country_name}
                  onChange={handleChange("country_name")}
                  className="bg-dark text-light border-light input-placeholder-light"
                />
                {errors?.country_name && touched?.country_name ? (
                  <span className="text-danger">{errors?.country_name}</span>
                ) : null}
              </div>
              {/* country_code */}
              <div className="col-md-6 mb-3">
                <Form.Label>Country Code*</Form.Label>
                <Form.Control
                  type="text"
                  name="country_code"
                  placeholder="Enter Country Code"
                  value={values.country_code}
                  onChange={handleChange("country_code")}
                  className="bg-dark text-light border-light input-placeholder-light"
                />
                {errors?.country_code && touched?.country_code ? (
                  <span className="text-danger">{errors?.country_code}</span>
                ) : null}
              </div>
              {/* iso3_code */}
              <div className="col-md-6 mb-3">
                <Form.Label>ISO-3 Code</Form.Label>
                <Form.Control
                  type="text"
                  name="iso3_code"
                  placeholder="Enter ISO-3 Code"
                  value={values.iso3_code}
                  onChange={handleChange("iso3_code")}
                  className="bg-dark text-light border-light input-placeholder-light"
                />
                {errors?.iso3_code && touched?.iso3_code ? (
                  <span className="text-danger">{errors?.iso3_code}</span>
                ) : null}
              </div>
              {/* numeric_code */}
              <div className="col-md-6 mb-3">
                <Form.Label>Numeric Code</Form.Label>
                <Form.Control
                  type="text"
                  name="numeric_code"
                  placeholder="Enter Numeric Code"
                  value={values.numeric_code || ""}
                  onChange={handleChange("numeric_code")}
                  className="bg-dark text-light border-light input-placeholder-light"
                />
              </div>
              {/* capital */}
              <div className="col-md-6 mb-3">
                <Form.Label>Capital</Form.Label>
                <Form.Control
                  type="text"
                  name="capital"
                  placeholder="Enter country abbreviation"
                  value={values.capital}
                  onChange={handleChange("capital")}
                  className="bg-dark text-light border-light input-placeholder-light"
                />
              </div>
              {/* native_name */}
              <div className="col-md-6 mb-3">
                <Form.Label>Native Name</Form.Label>
                <Form.Control
                  type="text"
                  name="native_name"
                  placeholder="Enter Native Name"
                  value={values.native_name}
                  onChange={handleChange("native_name")}
                  className="bg-dark text-light border-light input-placeholder-light"
                />
              </div>
              <div className="constainer-fluid">
                <div className="d-flex justify-content-end">
                  {loading && (
                    <div className="mt-4 mx-2">
                      <LoadingSpinner size={"lg"} />
                    </div>
                  )}
                  <Button
                    variant="secondary"
                    onClick={() => {
                      handleCloseAddEditModal();
                    }}
                    className="mt-3 mx-2"
                  >
                    Close
                  </Button>
                  <Button
                    variant="success"
                    className="mt-3"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    {selectedCountry?.id ? "Update" : "Add Country"}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default AddEditCountryModal;
